// extracted by mini-css-extract-plugin
export default {"wrapper":"LinkWithIcon_wrapper__NVoIc","label":"LinkWithIcon_label__mg6Pm"};